import type { IconData } from '@stacksjs/iconify-core'

export const skull2: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M20.113 38.66C10.928 37.032 4 29.744 4 21c0-9.941 8.954-18 20-18c10.673 0 19.393 7.524 19.97 17H44v12.5c0 4.15-.12 6.862-.251 8.58c-.13 1.709-1.231 3.055-2.92 3.34c-1.753.297-4.547.58-8.829.58s-7.076-.283-8.829-.58c-1.689-.285-2.79-1.631-2.92-3.34a73 73 0 0 1-.139-2.42Z\"/><path d=\"M40 18a4 5 0 1 0 0 10a4 5 0 1 0 0-10m-18 5a4 5 0 1 0 8 0a4 5 0 1 0-8 0m7 16v5.75M36 39v5.75\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default skull2
